@if(!hasSchedules || settingForms()) {
<p-dialog
  header="Send Settings"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ 'width': '460px', 'max-height': '540px' }"
  (onShow)="onShow()"
>
  <div class="radio-buttons-container">
    <div class="radio-button">
      <p-radiobutton
        value="once"
        inputId="sendOnce"
        [formControl]="radioButtonControl"
      ></p-radiobutton>
      <label for="sendOnce" class="radio-button-label">Send Once</label>
    </div>
    <div class="radio-button">
      <p-radiobutton
        value="recurring"
        inputId="recurring"
        [formControl]="radioButtonControl"
      ></p-radiobutton>
      <label for="recurring" class="radio-button-label"
        >Set Up Recurring Sending</label
      >
    </div>
  </div>
  @if(radioButtonControl.value === 'once') {
  <form [formGroup]="onceForm" class="form-container">
    <lib-dm-select-lib
      [options]="destinationOptions"
      [filter]="false"
      label="Destination"
      placeholder="Destination"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="destination"
      [appendToBody]="true"
    />
    @if(onceForm.get('destination')!.value === 'email') {
    <lib-dm-input-text-lib
      [control]="onceForm.get('email')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email"
      placeholder="Email"
    />
    <lib-dm-input-text-lib
      [control]="onceForm.get('emailSubject')"
      label="Email Subject"
      placeholder="Email Subject"
    />
    <lib-dm-input-text-lib
      [control]="onceForm.get('emailCC')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email CC"
      placeholder="Email CC"
    />
    <lib-dm-input-text-lib
      [control]="onceForm.get('emailBCC')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email BCC"
      placeholder="Email BCC"
    />
    } @else {
    <lib-dm-input-text-lib
      [control]="onceForm.get('connectionId')"
      label="Connection ID"
      placeholder="Connection ID"
    ></lib-dm-input-text-lib>
    <lib-dm-input-text-lib
      [control]="onceForm.get('folderName')"
      label="Folder Name"
      placeholder="Folder Name"
    ></lib-dm-input-text-lib>
    <lib-dm-input-text-lib
      [control]="onceForm.get('fileName')"
      [hint]="fileNameHint"
      [permanentHint]="true"
      label="File Name"
      placeholder="File Name"
      [suggestionsList]="onceFileNameVariables"
      [autocomplete]="true"
      [searchCharacter]="'#'"
      [showEmptyMessage]="false"
      [appendToBody]="true"
    ></lib-dm-input-text-lib>
    <lib-dm-select-lib
      [options]="dateTimeFormatOptions()"
      [filter]="false"
      [hint]="dateTimeFormatHint"
      [permanentHint]="true"
      label="Date Time Format"
      formControlName="dateTimeFormat"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      [appendToBody]="true"
    ></lib-dm-select-lib>
    }
  </form>
  } @else {
  <form [formGroup]="recurringForm" class="form-container">
    <lib-dm-input-text-lib
      [control]="recurringForm.get('scheduleName')"
      label="Name"
      placeholder="Name"
    />
    <lib-dm-select-lib
      [options]="destinationOptions"
      [isMultiSelect]="false"
      [filter]="false"
      label="Destination"
      placeholder="Destination"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="destination"
      [appendToBody]="true"
    />
    @if(recurringForm.get('destination')!.value === 'email') {
    <lib-dm-input-text-lib
      [control]="recurringForm.get('email')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email"
      placeholder="Email"
    />
    <lib-dm-input-text-lib
      [control]="recurringForm.get('emailSubject')"
      label="Email Subject"
      placeholder="Email Subject"
    />
    <lib-dm-input-text-lib
      [control]="recurringForm.get('emailCC')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email CC"
      placeholder="Email CC"
    />
    <lib-dm-input-text-lib
      [control]="recurringForm.get('emailBCC')"
      [hint]="emailHint"
      [errorMessage]="emailErrorMessage"
      label="Email BCC"
      placeholder="Email BCC"
    />
    } @else {
    <lib-dm-input-text-lib
      [control]="recurringForm.get('connectionId')"
      label="Connection ID"
      placeholder="Connection ID"
    ></lib-dm-input-text-lib>
    <lib-dm-input-text-lib
      [control]="recurringForm.get('folderName')"
      label="Folder Name"
      placeholder="Folder Name"
    ></lib-dm-input-text-lib>
    <lib-dm-input-text-lib
      [control]="recurringForm.get('fileName')"
      [hint]="fileNameHint"
      [permanentHint]="true"
      label="File Name"
      placeholder="File Name"
      [suggestionsList]="fileNameVariables"
      [autocomplete]="true"
      [searchCharacter]="'#'"
      [showEmptyMessage]="false"
      [appendToBody]="true"
    ></lib-dm-input-text-lib>
    <lib-dm-select-lib
      [options]="dateTimeFormatOptions()"
      [filter]="false"
      [hint]="dateTimeFormatHint"
      [permanentHint]="true"
      label="Date Time Format"
      formControlName="dateTimeFormat"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      [appendToBody]="true"
    ></lib-dm-select-lib>
    }
    <lib-dm-date-picker-lib
      label="Expiration Date"
      formControlName="expirationDate"
      [appendToBody]="true"
    />
    <lib-dm-select-lib
      [options]="scheduleOptions"
      [filter]="false"
      [isMultiSelect]="false"
      label="Schedule"
      placeholder="Schedule"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="schedule"
      [appendToBody]="true"
    />
    @if(recurringForm.value?.schedule === '1') {
    <lib-dm-select-lib
      [options]="dayOfWeekOptions"
      [filter]="false"
      [isMultiSelect]="false"
      label="Day of Week"
      placeholder="Day Of Week"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="dayOfWeek"
      [appendToBody]="true"
    />
    } @if(recurringForm.value?.schedule === '2') {
    <lib-dm-select-lib
      [options]="dayOfMonthOptions"
      [filter]="false"
      [isMultiSelect]="false"
      label="Day of Month"
      placeholder="Day of Month"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="dayOfMonth"
      [appendToBody]="true"
    />
    }
    <lib-dm-select-lib
      [options]="timeUtcOptions"
      [filter]="false"
      [isMultiSelect]="false"
      label="Time (UTC)"
      optionLabel="lookup_value"
      optionValue="lookup_key"
      formControlName="time"
      [appendToBody]="true"
    />
  </form>
  }
  <div class="modal-footer">
    <lib-dm-button-lib
      text="Cancel"
      size="medium"
      variant="secondary-outlined"
      (outsideClickEmitter)="visible.set(false)"
    />
    @if(radioButtonControl.value === 'once') {
    <lib-dm-button-lib
      text="Send Now"
      size="medium"
      variant="primary-filled"
      [disabled]="onceForm.invalid"
      (outsideClickEmitter)="sendNow()"
    >
      @if(!loading()) {
      <div class="dm-button-icon" icon-left>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.1126 5.06654L9.72433 11.4548L11.6686 16.4544L16.1126 5.06654ZM8.54582 10.2763L14.9341 3.88803L3.5463 8.33205L8.54582 10.2763ZM17.2069 1.22851C17.3596 1.18417 17.6666 1.10449 17.9965 1.21467C18.3691 1.33915 18.6615 1.63157 18.786 2.00419C18.8962 2.334 18.8165 2.64105 18.7721 2.7937C18.7238 2.96006 18.6464 3.15833 18.5687 3.35725L13.0542 17.4882C12.9675 17.7106 12.8835 17.9259 12.8013 18.0921C12.7303 18.2358 12.5722 18.541 12.2442 18.7115C11.8825 18.8994 11.4518 18.8991 11.0903 18.7108C10.7625 18.54 10.6048 18.2345 10.534 18.0908C10.452 17.9245 10.3682 17.709 10.2818 17.4866L8.1068 11.8938L2.54348 9.73033C2.53368 9.72652 2.52388 9.72271 2.5141 9.71891C2.29163 9.63242 2.07618 9.54867 1.90985 9.46667C1.76613 9.39582 1.46067 9.23811 1.28988 8.9103C1.10153 8.5488 1.10128 8.11818 1.2892 7.75646C1.4596 7.42845 1.76488 7.27038 1.90851 7.19936C2.07475 7.11717 2.2901 7.03316 2.51247 6.94642C2.52225 6.9426 2.53204 6.93878 2.54184 6.93496L16.6434 1.43191C16.8423 1.35425 17.0406 1.27683 17.2069 1.22851Z"
            fill="white"
          />
        </svg>
      </div>
      } @if(loading()) {
      <div class="dm-button-icon" icon-left>
        <p-progress-spinner
          strokeWidth="6"
          [style]="{ width: '20px', height: '20px' }"
        />
      </div>
      }
    </lib-dm-button-lib>
    } @else {
    <lib-dm-button-lib
      text="Save Schedule"
      size="medium"
      variant="primary-filled"
      [disabled]="recurringForm.invalid || (currentSchedule && !formWasChanged())"
      (outsideClickEmitter)="saveSchedule()"
    >
      @if(!loading()) {
      <div class="dm-button-icon" icon-left>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8369 3.35628C12.7633 3.33861 12.6754 3.33326 12.2281 3.33326H6.66602V5.33326C6.66602 5.58036 6.66666 5.71557 6.6746 5.81273C6.67492 5.8166 6.67524 5.82026 6.67556 5.82371C6.67902 5.82403 6.68268 5.82435 6.68654 5.82467C6.7837 5.83261 6.91891 5.83326 7.16602 5.83326H12.8327C13.0798 5.83326 13.215 5.83261 13.3122 5.82467C13.316 5.82435 13.3197 5.82403 13.3231 5.82372C13.3235 5.82026 13.3238 5.8166 13.3241 5.81273C13.332 5.71557 13.3327 5.58036 13.3327 5.33326V3.67996C13.1758 3.52635 13.1264 3.48587 13.0777 3.45606C13.0032 3.41036 12.9219 3.37669 12.8369 3.35628ZM14.7552 2.74389L14.703 2.69171C14.6865 2.67522 14.6701 2.65884 14.6539 2.6426C14.4144 2.40261 14.2032 2.19102 13.9486 2.03499C13.7249 1.89792 13.481 1.79691 13.2259 1.73566C12.9356 1.66595 12.6366 1.66623 12.2975 1.66655C12.2746 1.66657 12.2514 1.66659 12.2281 1.66659L6.46493 1.66659C6.25739 1.66659 6.06106 1.66658 5.87552 1.66767C5.86133 1.66695 5.84705 1.66659 5.83268 1.66659C5.81429 1.66659 5.79604 1.66718 5.77795 1.66836C5.40448 1.67146 5.07624 1.67999 4.78949 1.70342C4.32108 1.74169 3.89049 1.82382 3.48605 2.0299C2.85884 2.34948 2.34891 2.85941 2.02933 3.48662C1.82325 3.89107 1.74112 4.32165 1.70284 4.79007C1.666 5.24106 1.66601 5.7947 1.66602 6.46551V13.5343C1.66601 14.2051 1.666 14.7588 1.70284 15.2098C1.74112 15.6782 1.82325 16.1088 2.02933 16.5132C2.34891 17.1404 2.85884 17.6504 3.48605 17.9699C3.89049 18.176 4.32108 18.2582 4.78949 18.2964C5.07624 18.3199 5.40448 18.3284 5.77794 18.3315C5.79604 18.3327 5.81429 18.3333 5.83268 18.3333C5.84705 18.3333 5.86133 18.3329 5.87552 18.3322C6.06105 18.3333 6.25737 18.3333 6.46491 18.3333H13.5338C13.7413 18.3333 13.9376 18.3333 14.1232 18.3322C14.1374 18.3329 14.1516 18.3333 14.166 18.3333C14.1844 18.3333 14.2027 18.3327 14.2208 18.3315C14.5942 18.3284 14.9225 18.3199 15.2092 18.2964C15.6776 18.2582 16.1082 18.176 16.5127 17.9699C17.1399 17.6504 17.6498 17.1404 17.9694 16.5132C18.1754 16.1088 18.2576 15.6782 18.2959 15.2098C18.3327 14.7588 18.3327 14.2052 18.3327 13.5344V7.77116C18.3327 7.74782 18.3327 7.72468 18.3327 7.70173C18.333 7.36265 18.3333 7.0637 18.2636 6.77333C18.2024 6.51824 18.1014 6.27438 17.9643 6.0507C17.8083 5.79608 17.5967 5.58489 17.3567 5.34535C17.3404 5.32913 17.3241 5.31278 17.3076 5.29629L14.7552 2.74389C14.7552 2.74396 14.7551 2.74382 14.7552 2.74389ZM14.9994 5.3451V5.35982C14.9994 5.57015 14.9994 5.77498 14.9852 5.94845C14.9697 6.13894 14.9329 6.36372 14.8177 6.58991C14.6579 6.90351 14.4029 7.15848 14.0893 7.31827C13.8631 7.43351 13.6384 7.47024 13.4479 7.4858C13.2744 7.49997 13.0696 7.49995 12.8593 7.49992L7.16602 7.49992C7.15715 7.49992 7.14829 7.49992 7.13944 7.49992C6.92912 7.49995 6.72429 7.49997 6.55082 7.4858C6.36033 7.47024 6.13555 7.43351 5.90937 7.31827C5.59576 7.15848 5.34079 6.90351 5.18101 6.58991C5.06576 6.36372 5.02903 6.13894 5.01347 5.94845C4.9993 5.77498 4.99932 5.57016 4.99935 5.35984C4.99935 5.35099 4.99935 5.34212 4.99935 5.33326V3.35897C4.97416 3.36071 4.94946 3.36257 4.92521 3.36455C4.55987 3.3944 4.37303 3.4485 4.2427 3.51491C3.9291 3.6747 3.67413 3.92967 3.51434 4.24327C3.44793 4.3736 3.39383 4.56044 3.36398 4.92579C3.33333 5.30086 3.33268 5.78611 3.33268 6.49992V13.4999C3.33268 14.2137 3.33333 14.699 3.36398 15.0741C3.39383 15.4394 3.44793 15.6262 3.51434 15.7566C3.67413 16.0702 3.9291 16.3251 4.2427 16.4849C4.37303 16.5513 4.55987 16.6054 4.92521 16.6353C4.94946 16.6373 4.97416 16.6391 4.99935 16.6409L4.99935 12.14C4.99932 11.9297 4.9993 11.7249 5.01347 11.5514C5.02903 11.3609 5.06576 11.1361 5.18101 10.9099C5.34079 10.5963 5.59576 10.3414 5.90937 10.1816C6.13555 10.0663 6.36033 10.0296 6.55082 10.014C6.72429 9.99987 6.92912 9.9999 7.13945 9.99992H12.8593C13.0696 9.9999 13.2744 9.99987 13.4479 10.014C13.6384 10.0296 13.8631 10.0663 14.0893 10.1816C14.4029 10.3414 14.6579 10.5963 14.8177 10.9099C14.9329 11.1361 14.9697 11.3609 14.9852 11.5514C14.9994 11.7249 14.9994 11.9297 14.9994 12.14L14.9993 16.6409C15.0245 16.6391 15.0492 16.6373 15.0735 16.6353C15.4388 16.6054 15.6257 16.5513 15.756 16.4849C16.0696 16.3251 16.3246 16.0702 16.4844 15.7566C16.5508 15.6262 16.6049 15.4394 16.6347 15.0741C16.6654 14.699 16.666 14.2137 16.666 13.4999V7.77116C16.666 7.32384 16.6607 7.23601 16.643 7.16241C16.6226 7.07738 16.5889 6.99609 16.5432 6.92153C16.5037 6.85699 16.4453 6.7911 16.129 6.4748L14.9994 5.3451ZM13.3327 16.6666V12.1666C13.3327 11.9195 13.332 11.7843 13.3241 11.6871C13.3238 11.6832 13.3235 11.6796 13.3231 11.6761C13.3197 11.6758 13.316 11.6755 13.3122 11.6752C13.215 11.6672 13.0798 11.6666 12.8327 11.6666H7.16602C6.91891 11.6666 6.7837 11.6672 6.68654 11.6752C6.68268 11.6755 6.67902 11.6758 6.67556 11.6761C6.67524 11.6796 6.67492 11.6832 6.6746 11.6871C6.66666 11.7843 6.66602 11.9195 6.66602 12.1666V16.6666H13.3327Z"
            fill="white"
          />
        </svg>
      </div>
      } @if(loading()) {
      <div class="dm-button-icon" icon-left>
        <p-progress-spinner
          strokeWidth="6"
          [style]="{ width: '20px', height: '20px' }"
        />
      </div>
      }
    </lib-dm-button-lib>
    }
  </div>
  <!--  <ng-template pTemplate="footer">-->
  <!--  </ng-template>-->
</p-dialog>
} @else {
<p-dialog
  header="Send Report"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ 'min-width': '720px' }"
>
  @if(scheduleItems().length) {
  <div class="schedule-list-container">
    <lib-dm-button-lib
      text="New Sending"
      size="medium"
      variant="primary-filled"
      (outsideClickEmitter)="newSending()"
    >
      <div class="dm-button-icon" icon-left [ngStyle]="{ height: '20px' }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0007 3.33331C10.4609 3.33331 10.834 3.70641 10.834 4.16665V9.16665H15.834C16.2942 9.16665 16.6673 9.53974 16.6673 9.99998C16.6673 10.4602 16.2942 10.8333 15.834 10.8333H10.834V15.8333C10.834 16.2936 10.4609 16.6666 10.0007 16.6666C9.54041 16.6666 9.16732 16.2936 9.16732 15.8333V10.8333H4.16732C3.70708 10.8333 3.33398 10.4602 3.33398 9.99998C3.33398 9.53974 3.70708 9.16665 4.16732 9.16665H9.16732V4.16665C9.16732 3.70641 9.54041 3.33331 10.0007 3.33331Z"
            fill="white"
          />
        </svg>
      </div>
    </lib-dm-button-lib>
    <table class="list-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Receiver</th>
          <th>Schedule</th>
          <th>Time of Day</th>
          <th [ngStyle]="{'min-width': '80px'}">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (item of scheduleItems(); track item.dag_id) {
        <tr>
          <td><span>{{ item.schedule_name }}</span></td>
          <td>
            <span
              >{{ item.connection_details.connection_type === 'email' ?
              item.connection_details.email_to :
              item.connection_details.connection_id }}</span
            >
          </td>
          <td><span>{{ item.schedule_type }}</span></td>
          <td><span>{{ item.time_option }}</span></td>
          <td class="cell-actions" [ngStyle]="{'min-width': '80px'}">
            <span class="cell-icon" (click)="editSchedule(item)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.862 1.52861C11.8587 0.531884 13.4747 0.531886 14.4714 1.52861C15.4682 2.52534 15.4682 4.14136 14.4714 5.13809L12.4732 7.13634C12.4726 7.13692 12.472 7.13751 12.4714 7.13809C12.4708 7.13867 12.4703 7.13926 12.4697 7.13984L5.66723 13.9423C5.65605 13.9534 5.64498 13.9645 5.63399 13.9755C5.47073 14.1391 5.32671 14.2833 5.1556 14.3961C5.00516 14.4954 4.842 14.5738 4.67056 14.6293C4.47555 14.6924 4.27295 14.7147 4.04326 14.7401C4.02781 14.7418 4.01224 14.7435 3.99654 14.7452L1.74029 14.9959C1.53901 15.0183 1.33847 14.948 1.19527 14.8048C1.05206 14.6616 0.981717 14.461 1.00408 14.2597L1.25478 12.0035C1.25652 11.9878 1.25824 11.9722 1.25994 11.9567C1.28528 11.7271 1.30763 11.5245 1.37075 11.3295C1.42626 11.158 1.50467 10.9949 1.60388 10.8444C1.71671 10.6733 1.86096 10.5293 2.02449 10.366C2.03549 10.355 2.04658 10.344 2.05775 10.3328L10.862 1.52861ZM9.33335 4.94283L3.00056 11.2756C2.78556 11.4906 2.74564 11.535 2.71698 11.5784C2.68391 11.6286 2.65777 11.683 2.63927 11.7401C2.62324 11.7896 2.61353 11.8485 2.57995 12.1507L2.42129 13.5787L3.8493 13.4201C4.15149 13.3865 4.21037 13.3768 4.25991 13.3608C4.31706 13.3422 4.37144 13.3161 4.42159 13.283C4.46505 13.2544 4.50941 13.2145 4.72442 12.9995L11.0572 6.66668L9.33335 4.94283ZM12 5.72387L10.2762 4.00002L11.8048 2.47142C12.2808 1.99539 13.0526 1.99539 13.5286 2.47142C14.0046 2.94745 14.0046 3.71925 13.5286 4.19528L12 5.72387Z"
                  fill="#5D6983"
                />
              </svg>
            </span>
            <span
              class="cell-icon"
              (click)="showDeleteConfirmation.set(true); mailTo = item.connection_details.email_to; scheduleId = item.schedule_id; scheduleGroupId = item.schedule_group_id;"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.44162 0.666688H8.55968C8.91111 0.666676 9.21429 0.666665 9.464 0.687068C9.72757 0.708602 9.98971 0.756146 10.242 0.884675C10.6183 1.07642 10.9243 1.38238 11.116 1.75871C11.2445 2.01096 11.2921 2.27311 11.3136 2.53667C11.3319 2.76052 11.3338 3.02733 11.334 3.33336H14.0007C14.3688 3.33336 14.6673 3.63183 14.6673 4.00002C14.6673 4.36821 14.3688 4.66669 14.0007 4.66669H13.334V11.4942C13.334 12.0309 13.334 12.4738 13.3045 12.8346C13.2739 13.2093 13.2082 13.5538 13.0433 13.8773C12.7877 14.3791 12.3797 14.787 11.878 15.0427C11.5544 15.2076 11.2099 15.2733 10.8352 15.3039C10.4744 15.3334 10.0315 15.3334 9.49487 15.3334H6.50644C5.9698 15.3334 5.52689 15.3334 5.1661 15.3039C4.79137 15.2733 4.4469 15.2076 4.12334 15.0427C3.62158 14.787 3.21363 14.3791 2.95797 13.8773C2.79311 13.5538 2.7274 13.2093 2.69678 12.8346C2.6673 12.4738 2.66731 12.0309 2.66732 11.4942L2.66732 4.66669H2.00065C1.63246 4.66669 1.33398 4.36821 1.33398 4.00002C1.33398 3.63183 1.63246 3.33336 2.00065 3.33336H4.66734C4.66752 3.02733 4.66941 2.76052 4.6877 2.53667C4.70923 2.27311 4.75678 2.01096 4.8853 1.75871C5.07705 1.38238 5.38301 1.07642 5.75934 0.884675C6.01159 0.756146 6.27374 0.708602 6.5373 0.687068C6.78701 0.666665 7.09019 0.666676 7.44162 0.666688ZM4.00065 4.66669V11.4667C4.00065 12.0377 4.00117 12.4259 4.02569 12.726C4.04957 13.0183 4.09285 13.1677 4.14598 13.272C4.27381 13.5229 4.47778 13.7269 4.72866 13.8547C4.83293 13.9078 4.9824 13.9511 5.27468 13.975C5.57474 13.9995 5.96293 14 6.53398 14H9.46732C10.0384 14 10.4266 13.9995 10.7266 13.975C11.0189 13.9511 11.1684 13.9078 11.2726 13.8547C11.5235 13.7269 11.7275 13.5229 11.8553 13.272C11.9085 13.1677 11.9517 13.0183 11.9756 12.726C12.0001 12.4259 12.0007 12.0377 12.0007 11.4667V4.66669H4.00065ZM10.0006 3.33336H6.0007C6.00099 3.02329 6.00303 2.81134 6.0166 2.64525C6.0314 2.46414 6.05652 2.39699 6.07331 2.36403C6.13723 2.23859 6.23922 2.1366 6.36466 2.07268C6.39762 2.05589 6.46477 2.03077 6.64588 2.01597C6.83477 2.00054 7.08295 2.00002 7.46732 2.00002H8.53398C8.91835 2.00002 9.16654 2.00054 9.35543 2.01597C9.53654 2.03077 9.60368 2.05589 9.63664 2.07268C9.76209 2.1366 9.86407 2.23859 9.92799 2.36403C9.94478 2.39699 9.9699 2.46414 9.9847 2.64525C9.99827 2.81134 10.0003 3.02329 10.0006 3.33336ZM6.66732 7.00002C7.03551 7.00002 7.33398 7.2985 7.33398 7.66669V11C7.33398 11.3682 7.03551 11.6667 6.66732 11.6667C6.29913 11.6667 6.00065 11.3682 6.00065 11V7.66669C6.00065 7.2985 6.29913 7.00002 6.66732 7.00002ZM9.33398 7.00002C9.70217 7.00002 10.0007 7.2985 10.0007 7.66669V11C10.0007 11.3682 9.70217 11.6667 9.33398 11.6667C8.96579 11.6667 8.66732 11.3682 8.66732 11V7.66669C8.66732 7.2985 8.96579 7.00002 9.33398 7.00002Z"
                  fill="#5D6983"
                />
              </svg>
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @else {
  <div class="loading-state">
    <p-progress-spinner
      strokeWidth="6"
      [style]="{ width: '40px', height: '40px' }"
    />
  </div>
  }
</p-dialog>
} @defer (when showDeleteConfirmation()) {
<lib-delete-template-modal
  [(loading)]="loading"
  [(visible)]="showDeleteConfirmation"
  (confirm)="deleteSchedule()"
  title="Delete Schedule"
  description="If the schedule is deleted, you will no longer receive reports.
Are you sure you want to delete the schedule?"
></lib-delete-template-modal>
}
